@if (draft) {
  <section class="editor-shell">
    <section class="editor-section">
      <button
        type="button"
        class="section-toggle"
        [attr.aria-expanded]="metadataExpanded"
        (click)="toggleSection('metadata')">
        <div>
          <p class="eyebrow">Metadata</p>
          <h3>Landing page definition</h3>
          <p class="section-summary">Title, path, summary, and search metadata.</p>
        </div>
        <span class="toggle-indicator">{{ metadataExpanded ? 'Hide' : 'Show' }}</span>
      </button>

      @if (metadataExpanded) {
        <div class="section-body">
          <cms-landing-page-metadata-form
            [landingPage]="draft"
            [hideHeader]="true"
            [tagSuggestions]="tagSuggestions"
            (landingPageChange)="updateDraft($event)" />
        </div>
      }
    </section>

    <section class="editor-section">
      <button
        type="button"
        class="section-toggle"
        [attr.aria-expanded]="publishingExpanded"
        (click)="toggleSection('publishing')">
        <div>
          <p class="eyebrow">Publishing</p>
          <h3>Release control</h3>
          <p class="section-summary">State, scheduling, and visibility indicators.</p>
        </div>
        <span class="toggle-indicator">{{ publishingExpanded ? 'Hide' : 'Show' }}</span>
      </button>

      @if (publishingExpanded) {
        <div class="section-body">
          <cms-publication-settings
            [landingPage]="draft"
            [hideHeader]="true"
            (landingPageChange)="updateDraft($event)" />

          @if (canDelete) {
            <section class="danger-panel">
              <div>
                <p class="eyebrow">Danger</p>
                <h4>Delete landingPage</h4>
                <p class="danger-copy">Remove this landingPage permanently. This action cannot be undone.</p>
              </div>
              <button type="button" class="danger" [disabled]="saving" (click)="deleteRequested.emit(draft.id)">
                Delete landingPage
              </button>
            </section>
          }
        </div>
      }
    </section>

    <section class="editor-section">
      <button
        type="button"
        class="section-toggle"
        [attr.aria-expanded]="structureExpanded"
        (click)="toggleSection('structure')">
        <div>
          <p class="eyebrow">Structure</p>
          <h3>Landing page parts</h3>
          <p class="section-summary">Arrange headings, text, media, embeds, and references.</p>
        </div>
        <span class="toggle-indicator">{{ structureExpanded ? 'Hide' : 'Show' }}</span>
      </button>

      @if (structureExpanded) {
        <div class="section-body">
          <cms-landing-page-blocks-editor
            [blocks]="draft.blocks"
            [hideHeader]="true"
            [availableImages]="availableImages"
            [availableGalleries]="availableGalleries"
            (blocksChange)="updateBlocks($event)" />
        </div>
      }
    </section>
  </section>
} @else {
  <section class="empty-editor">
    <p class="eyebrow">Editor</p>
    <h2>Select an landingPage</h2>
    <p>Choose an existing entry or create a new one to open the structured editor.</p>
  </section>
}
